import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'ctm-components';

import styles from './frequency_toggle.css';

/*
    Frequency Price Filter (Annual / Monthly) Button Toggle Component
 */
class FrequencyToggle extends PureComponent {

    constructor(props) {
        super(props);
        this.buttons = [
            {
                label: 'Annually',
                frequency: 'annual'
            },
            {
                label: 'Monthly',
                frequency: 'monthly'
            }
        ];
    }

    /**
     * Handles clicking on a button
     * @param {Event} event The elements event object
     * @param {String} btnFrequency The price frequency
     */
    handleClick = (event, btnFrequency) => {
        const { frequency, sortResults, setFrequencyFilter } = this.props;
        if (frequency !== btnFrequency) {
            sortResults(btnFrequency);
            setFrequencyFilter(btnFrequency);
        }
    };

    /**
     * Returns the Button UI Component
     * @param {string} btnFrequency Price Frequency
     * @returns {string} Button UI Component
     */
    getButtonUIComponent = (btnFrequency) => {
        const { frequency, UIComponentActive, UIComponent } = this.props;
        return frequency === btnFrequency ? UIComponentActive : UIComponent;
    };

    /**
     * Builds each of the Toggle Buttons from buttons
     * @returns {Array} buttons An array of Toggle buttons
     */
    getToggleButtons = () => {
        return this.buttons.map((obj) => (
            <Button
                className={styles.button}
                label={obj.label}
                icon={obj.icon}
                iconPosition={obj.iconPosition}
                onClickFunction={(event) => this.handleClick(event, obj.frequency)}
                key={obj.frequency}
                UIComponent={this.getButtonUIComponent(obj.frequency)}
            />
        ));
    };

    /**
     * Render the Frequency Toggle Buttons
     * @returns {Node} - Returns Frequency Toggle Component
     */
    render = () => <>{this.getToggleButtons()}</>;

}

FrequencyToggle.propTypes = {
    frequency: PropTypes.string,
    UIComponent: PropTypes.string,
    UIComponentActive: PropTypes.string,
    sortResults: PropTypes.func.isRequired,
    setFrequencyFilter: PropTypes.func.isRequired
};

export { FrequencyToggle };
